import { API } from "../api/utils";
import * as api from "../api/authAPI";
import { getPendingNotifications } from "../api/notificationAPI";
import * as types from "../constants/authConstants";
import * as Ntypes from "../constants/notificationConstants";
import {
  getStoredActiveSite,
  isSiteSelectionRequired,
  requireSiteSelection,
} from "../../utils/siteSelection";

export const initializeAuthAction = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const { error, data } = await api.getCurrentUser();

    if (error) {
      throw new Error(error);
    }
    if (data) {
      // Store only non-sensitive UI hints in localStorage.
      // Auth tokens must NEVER be stored in localStorage — they live in httpOnly cookies set by the server.
      if (!isSiteSelectionRequired() && !localStorage.getItem('site') && data.site) {
        localStorage.setItem('site', JSON.stringify({ "value": data.site.Site_ID, "label": data.site.Name }));
      }
      dispatch({
        type: types.GET_CURRENT_USER_SUCCESS,
        payload: data,
      });
      const activeSite = getStoredActiveSite();
      if (activeSite) {
        dispatch(setUserSite(activeSite));
      }
      try {
        const { errorN, dataN } = await getPendingNotifications();
        if (errorN) {
          throw new Error(errorN);
        }
        if (dataN) {
          dispatch({
            type: Ntypes.GET_NOTIFICATION_SUCCESS,
            payload: dataN,
          });
        }
      } catch (error) {
        dispatch({
          type: Ntypes.GET_NOTIFICATION_FAIL,
          payload: null,
        });
      }
    }
  } catch (error) {
    localStorage.setItem('site', JSON.stringify({ "label": null, "value": null }));
    localStorage.removeItem('site');
    dispatch({
      type: types.GET_CURRENT_USER_FAIL,
      payload: error,
    });
  }
};


export const getCurrentUserAction = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const { error, data } = await api.getCurrentUser();

    if (error) {
      throw new Error(error);
    }
    if (data) {
      if (!isSiteSelectionRequired() && !localStorage.getItem('site') && data.site) {
        localStorage.setItem('site', JSON.stringify({ "value": data.site.Site_ID, "label": data.site.Name }));
      }
      dispatch({
        type: types.GET_CURRENT_USER_SUCCESS,
        payload: data,
      });
      const activeSite = getStoredActiveSite();
      if (activeSite) {
        dispatch(setUserSite(activeSite));
      }
      try {
        const { errorN, dataN } = await getPendingNotifications();
        if (errorN) {
          throw new Error(errorN);
        }
        if (dataN) {
          dispatch({
            type: Ntypes.GET_NOTIFICATION_SUCCESS,
            payload: dataN,
          });
        }
      } catch (error) {
        dispatch({
          type: Ntypes.GET_NOTIFICATION_FAIL,
          payload: null,
        });
      }
    }
  } catch (error) {
    dispatch({
      type: types.GET_CURRENT_USER_FAIL,
      payload: error,
    });
  }
};

export const signUPAction = (formData) => async (dispatch) => {
  try {
    const { error, data } = await api.signUP(formData);

    if (error) {
      throw new Error(error);
    }
    // Do NOT store tokens or user objects in localStorage — the server sets httpOnly cookies.
    dispatch({
      type: types.SIGNUP_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // error is a plain Error wrapping the already-clean message api.signUP
    // extracted via handleApiError — it has no .response, so read .message
    // (matches the pattern in logINAction below).
    const errorMessage = error.message || "Sign up failed. Please try again.";
    dispatch({
      type: types.SIGNUP_USER_FAIL,
      payload: errorMessage,
    });
  }
};

export const logINAction = (email, password) => async (dispatch) => {
  try {
    const { error, data } = await api.logIN(email, password);

    if (error) {
      throw new Error(error);
    }

    if (data) {
      requireSiteSelection();
      if (data.token) {
        localStorage.setItem("token", data.token);
        API.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      }
      dispatch({
        type: types.LOGIN_USER_SUCCESS,
        payload: data,
      });
      dispatch(initializeAuthAction());
    }
  } catch (error) {
    const errorMessage = error.response?.data?.detail || error.message || 'Login failed';
    dispatch({
      type: types.LOGIN_USER_FAIL,
      payload: errorMessage,
    });
    throw new Error(errorMessage);
  }
};

export const logoutAction = () => async (dispatch) => {
  try {
    const { error } = await api.logout();

    if (error) {
      throw new Error(error);
    }
    localStorage.removeItem("site");
    delete API.defaults.headers.common["Authorization"];
    dispatch({
      type: types.LOGOUT,
      payload: null,
    });
  } catch (error) {
    // Swallow logout errors — we still clear local state
    delete API.defaults.headers.common["Authorization"];
    dispatch({ type: types.LOGOUT, payload: null });
    localStorage.removeItem("site");
  }
};

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});

export const clearSignup = () => ({
  type: types.SIGNUP_USER_CLEAR,
});

export const setUserSite = (site) => ({
  type: types.SET_USER_SITE,
  payload: site
});
